import { Table, Button } from 'react-bootstrap';
import { useState } from 'react';


function Horario(props) {
	//M=Lunes - T=Martes - W=Miercoles - R=Jueves - F=Viernes - S=Sabado - U=Domingo
	const [matrizbloqueos] = useState([[false, false, false, false, false, false, false, false],
	[false, false, false, false, false, false, false, false],
	[false, false, false, false, false, false, false, false],
	[false, false, false, false, false, false, false, false],
	[false, false, false, false, false, false, false, false],
	[false, false, false, false, false, false, false, false],
	[false, false, false, false, false, false, false, false],
	[false, false, false, false, false, false, false, false],
	[false, false, false, false, false, false, false, false],
	[false, false, false, false, false, false, false, false],
	[false, false, false, false, false, false, false, false],
	[false, false, false, false, false, false, false, false],
	[false, false, false, false, false, false, false, false],
	[false, false, false, false, false, false, false, false]]);


	/*const[dias]=useState(['M','T','W','R','F','S']);
	const[horas]=useState(['06:30-07:30','07:30-08:30','08:30-09:30','09:30-10:30','10:30-11:30','11:30-12:30','12:30-13:30','13:30-14:30','14:30-15:30','15:30-16:30','16:30-17:30','17:30-18:30','18:30-19:30','19:30-20:30']);
	const[diasfiltro]=useState([]);
	const[horasfiltro]=useState([]);
	const[diahorafiltro]=useState([]);*/

	function desbloquear() {
		Object.keys(props.selectcursos).map((key3) => {
			var curso = props.selectcursos[key3];
			curso.keys = [];
			if (curso.matcur_activo) {
				curso.nrcs.map((data10) => {
					curso.profesores_seleccionados.map((data2, index) => {
						if (curso[data10]['PROFESOR'] === data2) {

							var dias = curso[data10]['DIAS'].split("/");
							var horas = curso[data10]['HORAS'].split("/");

							dias.map((data0, index0) => {
								var infodia = data0;
								var infohora = horas[index0].split("_");
								var horai = infohora[0];
								var horaf = infohora[1];

								props.tabla.map((data1, index1) => {
									data1.map((data2, index2) => {
										var info = data2.split('-');
										var diamatriz = info[0];
										var horaimatriz = info[1].replace(':', '');
										var horafmatriz = info[2].replace(':', '');
										if (infodia === diamatriz) {
											if (horai <= horaimatriz && horaf >= horafmatriz) {

											} else {
												if (curso.keys.findIndex((element) => element === data10) < 0) {
													curso.keys.push(data10);
													curso.count = 0;
													curso.countmax = curso.keys.length;
													curso.horario = [];
													curso.horario = curso[curso.keys[0]];
												}
											}
										}
									})
								})
							})
						}
					})
				})
			}
		}
		)
	}

	const onchangefiltrohora = (e) => {
		var horaboton = e.target.id.split("_");
		//var bloquear = false;

		matrizbloqueos[e.target.name].map((data, index) => {
			if (index !== 0) {
				var datomatriz = props.tabla[e.target.name][index].replaceAll(":", "");
				datomatriz = datomatriz.replaceAll("-", "_");
				var x = document.getElementsByClassName(datomatriz);
				if (data) {
					matrizbloqueos[e.target.name][index] = false;
					x[0].classList.remove("bloqueodiahora");
					desbloquear();
				} else {
					matrizbloqueos[e.target.name][index] = true;
					x[0].classList.add("bloqueodiahora");
					Object.keys(props.selectcursos).map((key3) => {
						var curso = props.selectcursos[key3];
						var horainicial = horaboton[0];
						var horafinal = horaboton[1];
						if (curso.matcur_activo) {
							curso.nrcs.map((data1) => {
								curso.keys.map((data2, index) => {
									if (data1 === data2) {
										var horas = curso[data2]['HORAS'].split("/");
										var sw = true;
										horas.map((data3) => {
											var horas2 = data3.split("_");
											var horadiacursoinicial = horas2[0];
											var horadiacursofinal = horas2[1];
											if (horadiacursoinicial <= horainicial && horadiacursofinal >= horafinal) {
												sw = false;
											}
										})
										if (!sw) {
											curso.keys.splice(index, 1);
											curso.count = 0;
											curso.countmax = curso.keys.length;
											curso.horario = [];
											curso.horario = curso[curso.keys[0]];
										}
									}
								})
							})
						}
					});
				}
			}
		})
		//console.log(props.selectcursos);
		//console.log(matrizbloqueos);
		props.setBloqueos(matrizbloqueos);
		props.setSelectcursos(props.selectcursos);
		props.setCursokey(!props.cursokey);
	}

	const onchangefiltrodia = (e) => {
		//var bloquear = false;
		matrizbloqueos.map((data, index) => {
			var datomatriz = props.tabla[index][e.target.name].replaceAll(":", "");
			datomatriz = datomatriz.replaceAll("-", "_");
			var x = document.getElementsByClassName(datomatriz);
			if (matrizbloqueos[index][e.target.name]) {
				matrizbloqueos[index][e.target.name] = false;
				x[0].classList.remove("bloqueodiahora");
				desbloquear();
			} else {
				matrizbloqueos[index][e.target.name] = true;
				x[0].classList.add("bloqueodiahora");

				Object.keys(props.selectcursos).map((key3) => {
					var curso = props.selectcursos[key3];
					if (curso.matcur_activo) {
						curso.nrcs.map((data1) => {
							curso.keys.map((data2, index) => {
								if (data1 === data2) {
									var dias = curso[data2]['DIAS'].split("/");
									if (dias.findIndex((element) => element === e.target.id) >= 0) {
										curso.keys.splice(index, 1);
										curso.count = 0;
										curso.countmax = curso.keys.length;
										curso.horario = [];
										curso.horario = curso[curso.keys[0]];
									}
								}
							})
						})
					}
				});
			}
		})
		//console.log(matrizbloqueos);
		props.setBloqueos(matrizbloqueos);
		props.setSelectcursos(props.selectcursos);
		props.setCursokey(!props.cursokey);
	}

	const onchangefiltrodiahora = (diahoras) => {
		//console.log(diahoras);
		var x = document.getElementsByClassName(diahoras);
		var info = diahoras.split("_");
		var dia = info[0];
		var horainicial = info[1].substring(0, 2) + ":" + info[1].substring(2);
		var horafinal = info[2].substring(0, 2) + ":" + info[2].substring(2);
		var diahora = dia + "-" + horainicial + "-" + horafinal;
		props.tabla.map((data, index) => {
			var index2 = data.findIndex((element) => element === diahora);
			if (index2 >= 0) {
				if (matrizbloqueos[index][index2]) {
					matrizbloqueos[index][index2] = false;
					x[0].classList.remove("bloqueodiahora");
					desbloquear();
				} else {
					matrizbloqueos[index][index2] = true;
					x[0].classList.add("bloqueodiahora");
					Object.keys(props.selectcursos).map((key3) => {
						var curso = props.selectcursos[key3];
						//var horainicial = horaboton[0];
						//var horafinal = horaboton[1];
						if (curso.matcur_activo) {
							curso.nrcs.map((data1) => {
								curso.keys.map((data2, index) => {
									if (data1 === data2) {
										var horas = curso[data2]['HORAS'].split("/");
										var dias = curso[data2]['DIAS'].split("/");
										var sw = true;
										horas.map((data3, index3) => {
											var horas2 = data3.split("_");
											var horadiacursoinicial = horas2[0];
											var horadiacursofinal = horas2[1];
											//console.log(dias[index3]+"==="+dia);
											//console.log(horadiacursoinicial+"<="+horainicial.replace(":","") +"&&"+ horadiacursofinal+">="+horafinal.replace(":",""));
											if (dias[index3] === dia) {
												if (horadiacursoinicial <= horainicial.replace(":", "") && horadiacursofinal >= horafinal.replace(":", "")) {
													//console.log("entro");
													sw = false;
													curso.keys.splice(index, 1);
													curso.count = 0;
													curso.countmax = curso.keys.length;
													curso.horario = [];
													curso.horario = curso[curso.keys[0]];
												}
											}
										})
										if (!sw) {

										}
									}
								})
							})
						}
					});
				}
			}
		})
		//console.log(matrizbloqueos);
		props.setBloqueos(matrizbloqueos);
		props.setSelectcursos(props.selectcursos);
		props.setCursokey(!props.cursokey);
	}


	const llenartabla = () => {
		return (
			<tbody>
				{props.tabla.map((data, index) => {
					return (
						<tr key={index}>
							{data.map((data2, index2) => {
								let nombre_curso = [];
								let profesor = [];
								let fechai = [];
								let fechaf = [];
								let nrc = [];
								let matcur = [];
								let salondia = [];
								var diahora = data2.split('-');
								var dia = diahora[0];
								var horai = diahora[1].replace(':', '');
								var horaf = diahora[2].replace(':', '');
								let error = "";
								let mystyle = {};
								let mystyleError = {};
								let horaCurso = [];

								//console.log("1. horai = " + horai + " horaf = " + horaf );
								//console.log("matrizbloqueos[" + index + "][" + index2 + "] = " + matrizbloqueos[index][index2]);

								if (matrizbloqueos[index][index2] === false) {
									Object.keys(props.selectcursos).map((key3) => {
										var curso = props.selectcursos[key3];
										//console.log("curso = props.selectcursos[" + key3 + "] = " + props.selectcursos[key3]);
										//console.log("curso.matcur_activo = " + curso.matcur_activo);
										if (curso.matcur_activo) {
											if (curso.horario !== undefined) {
												let dias = curso.horario['DIAS'].split('/');
												let horas = curso.horario['HORAS'].split('/');
												let salon = curso.horario['SALON'] !== null ? curso.horario['SALON'].split('/') : "X";
												let fechas = curso.horario['FECHAS'].replace(/:/g, '').split('/');
												dias.forEach(function (datadia, indicador) {
													let horadiacurso = horas[indicador].split('_');
													let horadiacursoinicial = horadiacurso[0];
													let horadiacursofinal = horadiacurso[1];

													let fechahoradiacurso = fechas[indicador].replace(/:/g, '').replace(/-/g, '/').split('_');
													//console.log(fechahoradiacurso);
													let fechaini = new Date((fechahoradiacurso[0]));
													//console.log(fechaini)
													let fechafin = new Date((fechahoradiacurso[1]));

													//console.log("horadiacurso = " + horadiacurso + "\n horadiacursoinicial = " + horadiacursoinicial + "\n horadiacursofinal = " + horadiacursofinal);

													//console.log("dia === dias[" + indicador + "]" + dia + "\t" + dias[indicador]);

													if (dia === dias[indicador]) {
														//console.log("horadiacursoinicial =" + horadiacursoinicial + " horai = " + horai + " horadiacursofinal = " + horadiacursofinal + " horaf = " + horaf  );
														//if(horadiacursoinicial<=horai && horadiacursofinal>=horaf){ V1
														//if (horadiacursoinicial >= horai && horadiacursofinal <= horaf) { V2
														if (((horai >= horadiacursoinicial && horaf >= horadiacursoinicial) && (horai <= horadiacursofinal && horaf >= horadiacursofinal)) || (horadiacursoinicial <= horai && horadiacursofinal >= horaf)) { /*V3*/
															matcur.push(key3);
															nombre_curso.push(curso.horario['NOMBRE_ASIGNATURA']);
															nrc.push(curso.horario['NRC']);
															salondia.push(salon[indicador]);
															profesor.push(curso.horario['PROFESOR']);
															fechai.push((fechaini.getDate()).toString().padStart(2, '0') + "/" + (fechaini.getMonth() + 1).toString().padStart(2, '0') + "/" + fechaini.getFullYear());
															fechaf.push((fechafin.getDate()).toString().padStart(2, '0') + "/" + (fechafin.getMonth() + 1).toString().padStart(2, '0') + "/" + fechafin.getFullYear());
															horaCurso.push(horadiacursoinicial + " - " + horadiacursofinal);
														}
													}
													if (nrc.length >= 2) {
														let sw = false;
														mystyle = { border: "1px dotted", padding: "5px", margin: "2px" };														
														const search_nrc = nrc.reduce((acc, array_nrc) => {
															const clave = JSON.stringify(array_nrc);
															acc[clave] = ++acc[clave] || 0;
															return acc;
														}, {});
														let duplicados = nrc.filter((nrc) => {
															return search_nrc[JSON.stringify(nrc)];
														});
														//while (sw === false) {
															if (duplicados && duplicados.length > 0) {
																//console.log("1")
																if (nrc.length !== duplicados.length) {
																	//console.log("1.1")
																	for (let x = 0; x < fechai.length; x++) {
																		for (let z = x+1; z < fechai.length; z++) {
																			if (fechai[x] === fechai[z] && fechaf[x] === fechaf[z]) {
																				//console.log("Iguales " + fechai[x] + " = " + fechai[z]);
																				mystyle = { border: "1px dotted", padding: "5px", margin: "2px", background:"indianred" };
																				sw = true;
																			}else{
																				if (((fechai[x] >= fechai[z]) && (fechai[x] <= fechaf[z])) && (fechaf[x] >= fechai[z]) && (fechaf[x] <= fechaf[z])) {
																					//console.log("aqui " + fechai[x] + " >= " + fechai[z]);
																					mystyle = { border: "1px dotted", padding: "5px", margin: "2px", background:"indianred" };
																					sw = true;
																				}
																			}
																		}
																	}
																}else{
																	sw= false;
																}
															} else {
																//console.log("2")
																for (let x = 0; x < fechai.length; x++) {
																	for (let z = x+1; z < fechai.length; z++) {
																		if (fechai[x] === fechai[z] && fechaf[x] === fechaf[z]) {
																			//console.log("Iguales " + fechai[x] + " = " + fechai[z]);
																			mystyle = { border: "1px dotted", padding: "5px", margin: "2px", background:"indianred" };
																			sw = true;
																		}else{
																			if (((fechai[x] >= fechai[z]) && (fechai[x] <= fechaf[z])) && (fechaf[x] >= fechai[z]) && (fechaf[x] <= fechaf[z])) {
																				//console.log("aqui " + fechai[x] + " >= " + fechai[z]);
																				mystyle = { border: "1px dotted", padding: "5px", margin: "2px", background:"indianred" };
																				sw = true;
																			}
																		}
																	}
																}
															}														
														//}
														if (sw === true) {
															error = "bg-danger";
														}
													}
												});
											}
										}
									})
								}
								return (
									index2 === 0 ?
										<th className="cell_table text-center" scope="row" key={index2}>
											<Button id={horai + "_" + horaf} name={index} className="btn_icon" variant="" onClick={onchangefiltrohora}>
												{diahora[1] + "-" + diahora[2]}
											</Button>
											<p className="infoprint">{horai + "_" + horaf}</p>
										</th> :
										<td className={error + " cell_table "} key={index2} onClick={() => onchangefiltrodiahora(dia + "_" + horai + "_" + horaf)}>
											<div className={dia + "_" + horai + "_" + horaf} >
												{/*<div className={dia+" "+horai+"_"+horaf+" "+dia+"_"+horai+"_"+horaf}>*/}
												{
													nrc.map((element, index) =>
														<div key={index} style={mystyle}>
															<p><strong>{nombre_curso[index]}</strong></p>
															<p><strong>Materia curso:</strong> {matcur[index] } </p>
													    	<p> <strong>NRC:</strong> {element} </p>
															<p><strong>Profesor:</strong> {profesor[index]}</p>
															<p><strong>Salón:</strong> {salondia[index]} </p>
															<p><strong>Inicio de clases:</strong> {fechai[index]} </p>
															<p><strong>fin de clases:</strong> {fechaf[index]} </p>
														</div>
													)
												}
											</div>
										</td>
								)
							})}
						</tr>
					)
				}
				)
				}
			</tbody>
		)
	}

	return (
		<Table responsive striped bordered variant="light" id="tablehorario">
			<thead>
				<tr>
					<th scope="col" className=" text-center"></th>
					<th scope="col" className="cell_table text-center">
						<Button id="M" name="1" className="btn_icon" variant="" onClick={onchangefiltrodia}>
							Lunes
						</Button>
						<p className="infoprint">Lunes</p>
					</th>
					<th scope="col" className="cell_table text-center">
						<Button id="T" name="2" className="btn_icon" variant="" onClick={onchangefiltrodia}>
							Martes
						</Button>
						<p className="infoprint">Martes</p>
					</th>
					<th scope="col" className="cell_table text-center">
						<Button id="W" name="3" className="btn_icon" variant="" onClick={onchangefiltrodia}>
							Miércoles
						</Button>
						<p className="infoprint">Miércoles</p>
					</th>
					<th scope="col" className="cell_table text-center">
						<Button id="R" name="4" className="btn_icon" variant="" onClick={onchangefiltrodia}>
							Jueves
						</Button>
						<p className="infoprint">Jueves</p>
					</th>
					<th scope="col" className="cell_table text-center">
						<Button id="F" name="5" className="btn_icon" variant="" onClick={onchangefiltrodia}>
							Viernes
						</Button>
						<p className="infoprint">Viernes</p>
					</th>
					<th scope="col" className="cell_table text-center">
						<Button id="S" name="6" className="btn_icon" variant="" onClick={onchangefiltrodia}>
							Sábado
						</Button>
						<p className="infoprint">Sábado</p>
					</th>
					<th scope="col" className="cell_table text-center">
						<Button id="U" name="7" className="btn_icon" variant="" onClick={onchangefiltrodia}>
							Domingo
						</Button>
						<p className="infoprint">Domingo</p>
					</th>
				</tr>
			</thead>
			{llenartabla()}
		</Table>
	);
}

export default Horario;

